import { Component, OnInit, Input,Output,EventEmitter,ViewChild } from '@angular/core';
import { GridDataResult, DataStateChangeEvent} from '@progress/kendo-angular-grid';
import { DialogService, DialogRef, DialogCloseResult } from '@progress/kendo-angular-dialog';
import {  RaService,DownloadService } from '../../core';
import DateTime  from 'typescript-dotnet-es6/System/Time/DateTime'
import { Observable } from 'rxjs';
import {modalComponent} from '../../common/component/modal/modal.component';
import { UserProfileService } from '../../core';

@Component({
  selector: 'app-gds-usage-report',
  templateUrl: './gds-usage-report.component.html',
  styleUrls: ['./gds-usage-report.component.scss']
})
export class GdsUsageReportComponent implements OnInit {
    public initialFilterStartDate: Date ;
    public initialFilterEndDate: Date ;
    public filterStartDate ;
    public filterEndDate ;
    public accountNameList: any[];
    public selectedAccountNames=new Array();
    public selectedAll: boolean;
    public selectedAmadeus: boolean=false;
    public selectedApollo: boolean=false;
    public selectedGalileo: boolean=false;
    public selectedSabre: boolean=false;
    public selectedWorldspan: boolean=false;
    public SelectedReport:String="RA";
    public selectedAccountNameList:String="";
    public showAccountList:boolean=true;
    public showBAROption:boolean=false;
    public dialogSelected:string;


  constructor(
    private service: RaService,
    private downloadService: DownloadService,
    private dialogService: DialogService,
    private userProfileService:UserProfileService) {
      if(this.userProfileService.data.UserName=="Lanyon.Master"){
        this.showBAROption=true;
     }
    }

  public onStartDateChange(value: Date): void {

      this.filterStartDate=this.convertDateTomdyyyyFormat(value);
      this.service.GetAccountNameListForGDSUSage(this.filterStartDate,this.filterEndDate)
      .subscribe( data => {
              this.accountNameList = data;
          },err=>{console.log(err)});
    }

  public onEndDateChange(value: Date): void {
      this.filterEndDate=this.convertDateTomdyyyyFormat(value);
      this.service.GetAccountNameListForGDSUSage(this.filterStartDate,this.filterEndDate).subscribe( data => {
            this.accountNameList = data;
          },err=>{console.log(err)});

    }


  checkAll(event:Event) {
     var chkboxes =<HTMLCollectionOf<HTMLInputElement>>document.getElementsByClassName('selectAllCheckbox');
    for (let i = 0; i < chkboxes.length; i++) {
       chkboxes[i].checked = this.selectedAccountNames[i] = this.selectedAll;
    }
  }

  updateCheckall = function(event:Event){
           
    var chkboxes =<HTMLCollectionOf<HTMLInputElement>>document.getElementsByClassName('selectAllCheckbox');
    var count = 0;
    for (let i = 0; i < chkboxes.length; i++) {
      if(chkboxes[i].checked){
        count++;
      }
   }
   this.selectedAll = (chkboxes.length == count);
  };

  buildSAUsageReport(event){
    this.SelectedReport="RA";
    this.showAccountList=true;
  }
  buildRIUsageReport(event){
    this.SelectedReport="RI";
    this.showAccountList=false;
  }
  buildBARUsageReport(event){
    this.SelectedReport="BAR";
    this.showAccountList=false;
  }
onBuildReport(){

 var parameterList;
 if(this.selectedAmadeus!=true && this.selectedApollo!=true && this.selectedGalileo!=true &&  this.selectedSabre!=true && this.selectedWorldspan!=true){
      this.dialogSelected="GDS Alert";
      this.modalDetails(this.dialogSelected);
 }
 else{
  // debugger;
   this.selectedAccountNameList="";
        for(var i = 0; i < this.accountNameList.length; i++)
          {
             if(!this.selectedAll)
              {
                  if(this.selectedAccountNames[i]==true)
                    {
                        this.selectedAccountNameList+=this.accountNameList[i]+"|";

                    }
              }
              else{
                 this.selectedAccountNameList+=this.accountNameList[i]+"|";

              }
          }
          if(  this.selectedAccountNameList=="" && this.SelectedReport!="RI" && this.SelectedReport!="BAR")
            {
                 this.dialogSelected="Account Name Alert";
                 this.modalDetails(this.dialogSelected);
            }
          else{

            this.downloadService.downloadUsageReport(this.filterStartDate,this.filterEndDate,String(this.selectedAmadeus),String(this.selectedApollo),String(this.selectedGalileo),
                          String(this.selectedSabre),String(this.selectedWorldspan),this.selectedAccountNameList,String(this.SelectedReport))
              .subscribe((data)=>{this.selectedAccountNameList="";},
                (err)=> {
                  console.log(err);

                }
              );
        }
 }
}



  ngOnInit() {


      this.selectedAll=false;
      this.initialFilterStartDate=DateTime.now.addDays(-60).toJsDate();
      this.filterStartDate = this.convertDateTomdyyyyFormat(this.initialFilterStartDate);
      this.initialFilterEndDate=DateTime.now.date.toJsDate();
      this.filterEndDate = this.convertDateTomdyyyyFormat(this.initialFilterEndDate);

        this.service.GetAccountNameListForGDSUSage(this.filterStartDate,this.filterEndDate).subscribe( data => {
            this.accountNameList = data;
          },err=>{console.log(err)});

  }

  public convertDateTomdyyyyFormat(date:Date){
  return (date.getMonth() + 1) + '/' + date.getDate() + '/' + date.getFullYear();
  }

  public modalDetails(alertType)
  {
    if(alertType=="GDS Alert"){
      this. dialogTitle="Select GDS ";
      this.dialogTextLine1="Please include at least one GDS";
      this.dialogTextLine2="";
      this.primaryButtonText="Ok";
      this.secondaryButtonText="";
      this.showModal(event);
    }
    else if(alertType=="Account Name Alert"){
      this. dialogTitle="Select Account Name ";
      this.dialogTextLine1="Please include at least one Account Name";
      this.dialogTextLine2="";
      this.primaryButtonText="Ok";
      this.secondaryButtonText="";
      this.showModal(event);
    }
  }

   @ViewChild(modalComponent, { static: false }) modalController: modalComponent;
   public dialogTitle:string;
   public dialogTextLine1:string;
   public dialogTextLine2:string;
   public primaryButtonText:string;
   public secondaryButtonText:string;

    public openModal:boolean=false;
    public kendoDialog:boolean=true;


   public showModal(xyz: any):void {
    this.openModal=true;
    const dialog: DialogRef = this.dialogService.open({
          content:modalComponent
      });
    }

    public closeModals():void {
      this.kendoDialog=false;
      this.openModal=false;
   }


    public okButtonClick():void {

      this.kendoDialog=false;
      this.openModal=false;
    }

}
